import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import TechnicalInfoService from '@/services/CatalogServices/TechnicalInfoService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: null,
    submitting: false,
    loading: false,
    errors: null,
    successOnCreate: '',
    parentHeaderList: [],
};

export const createTableHeader = createAsyncThunk(
    'table-header/createTableHeader',
    async (data, thunkApi) => {
        try {
            const { table_id: tableHeaderId } = data;
            let response;
            if (tableHeaderId) {
                response = await TechnicalInfoService.updateTableHeader(data, tableHeaderId);
            } else {
                response = await TechnicalInfoService.createTableHeader(data);
            }
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const viewTableHeader = createAsyncThunk(
    'table-header/viewTableHeader',
    async (tableHeaderId, thunkApi) => {
        try {
            const response = await TechnicalInfoService.viewTableHeader(tableHeaderId);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

export const getParentHeaderList = createAsyncThunk(
    'table-header/getParentHeaderList',
    async (id, thunkApi) => {
        try {
            const response = await TechnicalInfoService.getParentHeaderList(id);
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(extractError(error));
        }
    },
);

const createTableHeaderSlice = createSlice({
    name: 'createTableHeader',
    initialState: model,
    reducers: {
        resetTableHeaderSuccess: (state) => {
            state.successOnCreate = '';
            state.data = null;
        },
        resetTableHeaderError: (state) => {
            state.errors = null;
        },
        updateParentHeaderList: (state, action) => {
            state.parentHeaderList = !state.parentHeaderList.some(
                (item) => item.id === action.payload.id,
            ) && action.payload.id !== ''
                ? [...state.parentHeaderList, action.payload]
                : state.parentHeaderList;
        },
        resetParentHeaderList: (state) => {
            state.parentHeaderList = [];
        },
        resetTableHeaderState: (state) => {
            state.data = null;
            state.submitting = false;
            state.errors = null;
        },
    },
    extraReducers: (builder) => {
        // create table header
        builder.addCase(createTableHeader.pending, (state) => {
            state.submitting = true;
        }).addCase(createTableHeader.fulfilled, (state, action) => {
            state.submitting = false;
            state.successOnCreate = action.meta.arg.table_id ? 'Table header updated successfully!' : 'Table header created successfully!';
        }).addCase(createTableHeader.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });

        // view table header for edit
        builder.addCase(viewTableHeader.pending, (state) => {
            state.loading = true;
        }).addCase(viewTableHeader.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        }).addCase(viewTableHeader.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });

        // get parent header list
        builder.addCase(getParentHeaderList.pending, (state) => {
            state.loading = true;
        }).addCase(getParentHeaderList.fulfilled, (state, action) => {
            state.loading = false;
            state.parentHeaderList = action.payload;
        }).addCase(getParentHeaderList.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });
    },
});

export const {
    resetTableHeaderSuccess,
    resetTableHeaderError,
    updateParentHeaderList,
    resetParentHeaderList,
    resetTableHeaderState,
} = createTableHeaderSlice.actions;
export default createTableHeaderSlice.reducer;
